import { useSelector } from "react-redux";

import { Button } from "@material-ui/core";
import Modal from "@mui/material/Modal";
import ui from "../../assets/css/ui.module.scss";
import style from "../../assets/css/appModel.module.scss";
import AppSkeleton from "../Skeletons/AppSkeleton";
import CloseIcon from "../../assets/img/svgs/CloseIcon";

function AppModal({
  handleClose,
  action = null,
  title = "",
  heading = "",
  optionalHeading = "",
  actionLabel = "Report",
  cancelLabel = "Cancel",
  modalClass = "",
  headingClass = "",
  actionClass = "",
  isCloseBtnRequired = false,
  isFooterRequired = true,
  cancelLabelCls = "",
  children,
  hasCustomBody,
  headerWithCrossCls = "",
  isCancelBtnRequired = true,
  headingJSX: OptionalHeadingJSX = <></>,
  isOptionalHeadingJSX = false,
  crossIconWidth = 40,
  crossIconHeight = 40,
}) {
  const { loader } = useSelector((state) => state.app);

  return (
    <>
      <Modal open={true} onClose={handleClose}>
        <div className={style.container}>
          <div className={`${style.bodyBox} ${modalClass}`}>
            {isCloseBtnRequired ? (
              <div className={`${style.headerWithCross} ${headerWithCrossCls}`}>
                <div onClick={handleClose}>
                  <CloseIcon
                    color="#000"
                    height={crossIconHeight}
                    width={crossIconWidth}
                  />
                </div>
              </div>
            ) : (
              <div className={style.header}>{title}</div>
            )}
            {/* <div className={style.header}>{title}</div> */}
            {hasCustomBody ? (
              <>{children}</>
            ) : (
              <>
                <div
                  className={
                    loader
                      ? style.bodyPaddingBottom
                      : action
                      ? style.bodyPaddingBottom1
                      : style.bodyPaddingBottom2
                  }
                >
                  <div className={`${style.text1}${headingClass}`}>
                    {heading}
                  </div>
                  {isOptionalHeadingJSX ? (
                    OptionalHeadingJSX
                  ) : (
                    <>
                      {optionalHeading && (
                        <div className={style.text2}>{optionalHeading}</div>
                      )}
                    </>
                  )}
                </div>
                {loader ? (
                  <AppSkeleton variant="rounded" height={50} />
                ) : (
                  isFooterRequired && (
                    <div className={style.footer}>
                      <>
                        {action && (
                          <div className={style.btn1} onClick={action}>
                            <Button className={`${ui.btnBlack} ${actionClass}`}>
                              {actionLabel}
                            </Button>
                          </div>
                        )}
                        {isCancelBtnRequired && (
                          <div>
                            <Button
                              onClick={handleClose}
                              className={
                                cancelLabelCls ? cancelLabelCls : ui.btnWhite
                              }
                            >
                              {cancelLabel}
                            </Button>
                          </div>
                        )}
                      </>
                    </div>
                  )
                )}
              </>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
}

export default AppModal;
